import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules';
//import router from '../router'
import VueCookies from 'vue-cookies';
import { useRoute } from 'vue-router';
import router from '../router';
import { ENV_CDN_URL } from '../plugins/replaces'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		main: {
			clientMeta: {},
			clientPages: [],
			clientContent: {},
			clientPromotions: [],
			affiliateCheck: false,
			Languages: [],
			Locale: null,
			pokerStatus: null,
			BetSlip: false,
			bonusReceivable: [],
			SlotGame: null,
			specialTemplate:{},
			cdn_url: '',
			jackpots:{},
			image_theme: '/common/theme/dark',
			user_router: null,
			notification:[],
			maintenanceStatus: false,
		}
	},
	getters: {
		getJackpots(state) {
			return state.main.jackpots;
		},
		getCdnUrl(state) {
			return state.main.cdn_url;
		},
		getNotification(state) {
			return state.main.notification;
		},
		getBonusReceivable(state) {
			return state.main.bonusReceivable;
		},
		getClientMeta(state) {
			return state.main.clientMeta;
		},
		getClientPages(state) {
			return state.main.clientPages;
		},
		getClientContent(state) {
			return state.main.clientContent;
		},
		getClientPromotions(state) {
			return state.main.clientPromotions;
		},
		getAffiliateCheck(state) {
			return state.main.AffiliateCheck;
		},
		getLanguages(state) {
			return state.main.Languages;
		},
		getLocale(state) {
			return state.main.Locale;
		},
		getPokerStatus(state) {
			return state.main.pokerStatus;
		},
		getSpecialTemplate(state) {
			return state.main.specialTemplate;
		},
		getMaintenanceStatus(state) {
			return state.main.maintenanceStatus;
		},
		getBetSlip(state) {
			return state.main.BetSlip;
		},
		getSlotGame(state) {
			return state.main.SlotGame;
		},
		getUserRouter(state) {
			return state.main.user_router;
		}
	},
	mutations: {
		setJackpots(state, val) {
			state.main.jackpots = val;
		},
		setPragmaticJackpots(state, val) {
			state.main.jackpots.pragmaticplay.data.jackpots = val.jackpots;
		},
		setCdnUrl(state, val) {
			state.main.cdn_url = val;
		},
		setNotification(state, val) {
			state.main.notification = val;
		},
		setBonusReceivable(state, val) {
			state.main.bonusReceivable = val;
		},
		setClientMeta(state, val) {
			state.main.clientMeta = val;
		},
		setClientPages(state, val) {
			state.main.clientPages = val;
		},
		setClientContent(state, val) {
			state.main.clientContent = val;
		},
		setClientPromotions(state, val) {
			state.main.clientPromotions = val;
		},
		setAffiliateCheck(state, val) {
			state.main.affiliateCheck = val;
		},
		setLanguages(state, val) {
			state.main.Languages = val;
		},
		setLocale(state, val) {
			state.main.Locale = val;
		},
		setPokerStatus(state, val) {
			state.main.pokerStatus = val;
		},
		setMaintenanceStatus(state, val) {
			state.main.maintenanceStatus = val;
		},
		setSpecialTemplate(state, val) {
			state.main.specialTemplate = val;
		},
		setBetSlip(state, val) {
			state.main.BetSlip = val;
		},
		setSlotGame(state, val) {
			state.main.SlotGame = val;
		},
		setUserRouter(state, val) {
			state.main.user_router = val;
		},
	},
	actions: {
		BetSlipToggle({ commit }, payload) {
			commit('setBetSlip', payload);
		},
		initNotification({ commit }){
			return axios.get('user/notification')
				.then((response) => {
						if(response.data.status){
							if (!VueCookies.get(response.data.cookie)) {
								commit('setNotification', response.data);
							}
						}
				})
		},
		initUserBonus({ commit }){
				axios.get('/user/bonuses')
				.then((response) => {
						if(response.data.status){
							commit('setBonusReceivable', response.data.receivable);
						}
				})
		},
		hideBonus({ commit }){
				axios.patch('/user/bonus/hide')
				.then((response) => {
						if(response.data.status){
							commit('setBonusReceivable', []);
							this.$store.dispatch('alert/message', { type: 'success', msg: response.data.message }, { root: true })
						}
				})
		},
		closeNotify({ commit, state }, payload){
			if (payload == 'approve') {
				commit('setNotification', '');
			}else if(payload == 'notshow'){
					if (!_.isUndefined(state.main.notification.cookie)) {
							let date = new Date();
							date.setTime(date.getTime() + (30 * 60 * 1000));
							VueCookies.set(state.main.notification.cookie, '1', { expires: date});
					};
				commit('setNotification', '');
			}
		},
		initClient({ commit, dispatch, state }) {
			
			let route_a_id
			let first_visit = null
			if(localStorage.getItem('a_id')){
				route_a_id = localStorage.getItem('a_id')
				localStorage.setItem('first_visit', '0');
				first_visit = '0'
			}else{
				route_a_id = router.currentRoute.query.a_id
				if(route_a_id){
					localStorage.setItem('a_id', router.currentRoute.query.a_id);
					localStorage.setItem('first_visit', '1');
					first_visit = '1'
				}
			}

			let route_l_id = router.currentRoute.query.l_id
			
			dispatch('initNotification');
			return axios.get('init', { params: { l_id : (route_l_id ? route_l_id : null), a_id : (route_a_id ? route_a_id : null), first_visit : (first_visit ? first_visit : null) }})
				.then((response) => {
					if(response.data.data.is_maintenance){
						commit('setMaintenanceStatus', response.data.data.is_maintenance);
						router.push({name: "Maintenance"})
					}else{
						commit('setClientContent', response.data.data.content);
						commit('setClientMeta', response.data.data.meta);
						commit('setClientPages', response.data.data.pages);
						commit('setClientPromotions', response.data.data.promotions);
						commit('setAffiliateCheck', response.data.data.is_affiliate);
						commit('setLanguages', response.data.data.languages);
						commit('setLocale', response.data.data.ip_country);
						commit('setMaintenanceStatus', response.data.data.is_maintenance);
						commit('setPokerStatus', response.data.data.is_poker);
						commit('setJackpots', response.data.data.jackpots);
						commit('setSpecialTemplate', response.data.data.html);
						commit('setCdnUrl', response.data.data.cdn_url);
						if(response.data.data.last_winners){
							commit('slot/setWinners',  response.data.data.last_winners, { root: true })
						}
						

						if(process.env.NODE_ENV != 'development'){
							if(response.data.data.current_url != window.location.origin){
								window.location.href = response.data.data.current_url
							}
						}
						
						let customCss = document.createElement("style")
						customCss.innerText = response.data.data.custom_css
						//document.head.appendChild(customCss)		

					}
				})
				.catch((err) => {
				});
		},
		getBanner({ commit }, [page, device, section]) {
			return new Promise((resolve, reject) => {
				axios.get('banner', { params: { page: page, device: device, section: section } })
					.then(response => {
						resolve(response.data)
					});
			});
		},
		OpenSlotGame({ commit }, payload) {
			commit('setSlotGame', payload);
		}
	},
	modules: modules
})

